export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10805.2df7c447.jpg";